import React, { useContext } from 'react';
import styles from './OtherButton.module.css';
import { StepContext } from '../../../Steps/StepContainer';
import { OtherButtonProps } from './types';

export const OtherButton = ({
    text,
    formKey,
    formValue,
    displayFormKey,
    displayFormValue,
    dataClickLabel,
}: OtherButtonProps) => {
    const {
        handleNext,
        setFormValue,
        updateUserResume,
        setDisplayValue,
        formState,
    } = useContext(StepContext);

    const isSelected = Array.isArray(formKey)
        ? formState.userResumesAttributes[0][formKey[1]] === formValue[1]
        : formState[formKey] === formValue;

    const handleClick = () => {
        setDisplayValue(displayFormKey, displayFormValue);

        const isUserResumeUpdate =
            Array.isArray(formKey) &&
            Array.isArray(formValue) &&
            formKey[0] === 'userResumesAttributes';

        if (isUserResumeUpdate) {
            updateUserResume(formValue[0], formKey[1], formValue[1]);
        } else {
            setFormValue(formKey, formValue);
        }

        handleNext();
    };

    return (
        <div>
            <button
                data-click-label={dataClickLabel}
                className={`${styles.wrapper} ${isSelected ? styles.selected : ''}`}
                onClick={handleClick}
            >
                <p className={styles.text}>{text}</p>
            </button>
        </div>
    );
};
